import { PageItemCover as API } from '@src/api/types';
import { PageItemCover as Data } from '@src/types';

import generateMedia from './media';
import generateTranslations from './translations';

const Factory = (api: API): Data => {
  return {
    title: generateTranslations(api.title),
    description: generateTranslations(api.description),
    cover: generateMedia(api.media),
    link: api.link,
    entityType: api.entityType,
    entityId: api.entityId,
  };
};

export default Factory;
